import { render } from "./DarkOverlay.vue?vue&type=template&id=3fee3b75"
import script from "./DarkOverlay.vue?vue&type=script&lang=js"
export * from "./DarkOverlay.vue?vue&type=script&lang=js"

import "./DarkOverlay.vue?vue&type=style&index=0&id=3fee3b75&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__